import { FetchStatus, QueryObserverOptions, QueryStatus } from '@tanstack/react-query';

import { RequestStatus } from '@telialt/models/src/RequestModel';

export const getRequestStatus = (queryStatus: QueryStatus, fetchStatus: FetchStatus): RequestStatus => {
    if (queryStatus === RequestStatus.Pending && fetchStatus === RequestStatus.Idle) {
        return RequestStatus.Idle;
    }

    return queryStatus as RequestStatus;
};

export const isRequestBrowserError = (error: any) => {
    return error?.code === 'ERR_NETWORK' || error?.code === 'ECONNABORTED' || error?.code === 'ERR_CANCELED';
};

export const getPlaceholderData = (previousData: any, enabled: QueryObserverOptions['enabled']) => {
    return enabled ? previousData : undefined;
};
